import { useCallback, useEffect, useState } from 'react';
import {
  fetchInventory,
  type InventoryItem,
  type SizeItem,
} from '@/services/inventory';

export function useInventory() {
  const [inventory, setInventory] = useState<InventoryItem[]>([]);
  const [sizes, setSizes] = useState<SizeItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchInventory()
      .then((res) => {
        if (cancelled) return;
        setInventory(res.inventory);
        setSizes(res.sizes);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Error al cargar el inventario');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => load(), [load]);

  return { inventory, sizes, loading, error, refetch: load };
}